import { get } from "lodash";
import { EntityType } from "../api/transformers/investor";
import { InvestorName } from "../model";

export function fullName(obj: InvestorName) {
  if (obj.entityType === "IND") {
    return `${obj.title} ${obj.firstName} ${obj.surname}`;
  } else {
    return obj.entityName;
  }
}

type EntityTypeCategory = "INDIVIDUAL" | "CORPORATE" | "TRUST";
export function getEntityTypeCheckers(entityTypes: EntityType[]) {
  const is = (certainType: EntityTypeCategory) => (entityType?: string) => {
    const type = entityTypes.find((el) => el.id === entityType);
    if (type) {
      return type.type === certainType;
    }
    return false;
  };

  const getCategoryOfType = <R>(entityType: string, selector?: keyof EntityType | ((t: EntityType) => R)) => {
    const type = entityTypes.find((el) => el.id === entityType);
    if (type === undefined) {
      return undefined;
    }
    if (selector) {
      if (typeof selector === "string") {
        return get(type, selector);
      } else {
        return selector(type);
      }
    }
    return type;
  };

  return {
    isIndividual: is("INDIVIDUAL"),
    isTrust: is("TRUST"),
    isCorporate: is("CORPORATE"),
    getCategoryOfType,
  };
}

export const ENTITY_TYPE_CATEGORY = {
  TRUST: "TRUST",
  INDIVIDUAL: "INDIVIDUAL",
  CORPORATE: "CORPORATE"
};

export function isTrust(entityType: string) {
  return checkTypeCategory(entityType, ENTITY_TYPE_CATEGORY.TRUST);
}

export function isCorp(entityType: string) {
  return checkTypeCategory(entityType, ENTITY_TYPE_CATEGORY.CORPORATE);
}

export function isIndividual(entityType: string) {
  return checkTypeCategory(entityType, ENTITY_TYPE_CATEGORY.INDIVIDUAL);
}

export function getTypeCategory(entityType: string) {
  const entityTypes = getAllEntityType();
  const entityTypeObject = entityTypes.find((el: { id: string; }) => el.id === entityType);
  const formType = getFormType(entityTypeObject);
  if (formType) {
    return formType;
  }
  // Fallback: derive category from the raw entityType string when store is unavailable
  const code = (entityType || "").toUpperCase();
  if (!code) {
    return undefined as unknown as string;
  }
  if (code === ENTITY_TYPE_CATEGORY.TRUST || code.includes("TRUST")) {
    return ENTITY_TYPE_CATEGORY.TRUST;
  }
  if (code === ENTITY_TYPE_CATEGORY.INDIVIDUAL || code.startsWith("IND") || code.includes("INDIVIDUAL")) {
    return ENTITY_TYPE_CATEGORY.INDIVIDUAL;
  }
  if (code === ENTITY_TYPE_CATEGORY.CORPORATE || code.includes("CORP") || code.includes("COMPANY") || code.includes("ENTITY")) {
    return ENTITY_TYPE_CATEGORY.CORPORATE;
  }
  // Default to CORPORATE if unknown
  return ENTITY_TYPE_CATEGORY.CORPORATE;
}

export function getTypeDescription(entityType: string) {
  const entityTypes = getAllEntityType();
  const entityTypeObject = entityTypes.find((el: { id: string; }) => el.id === entityType);
  return get(entityTypeObject, "description", "");
}

function checkTypeCategory(entityType: string, typeCategory: string) {
  const tc = getTypeCategory(entityType);
  return tc === typeCategory;
}

function getAllEntityType() {
  const store = (window as any).reactStore;
  if (!store || typeof store.getState !== "function") {
    return [];
  }
  const state = store.getState();
  return get(state, "local.data.entityType", []);
}

function getFormType(entityTypeObject: any) {
  return get(entityTypeObject, "form.type", null);
}
